var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content !== null && _vm.content !== undefined && _vm.content !== '')?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({},on),[_vm._v("help")])]}}],null,false,1272764063)},[_c('div',{style:('font-family:' + _vm.fontFamily)},[_vm._v(_vm._s(_vm.content))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }